import { ErrorDialogContext } from '../../../../../components/ErrorDialog';
import { Routes } from '../../../../../constants/Routes';
import { URLSearchParamsMonad } from '../../../../../domains/base/SearchParams';
import { useContext } from '../../../../../hooks/useContext';
import { useReservationId } from '../../../../../hooks/useReservationId';
import { useTransaction } from '../../../../../hooks/useTransaction';
import { Payjp3dSecureStore } from '../../../store/Payjp3dSecureStore';
import { AccountDetailStore } from '../../stores/AccountDetailStore';

export const useActions = (store: AccountDetailStore, currentURL: URL) => {
  const { reservationId, push, encode } = useReservationId();
  const { setError } = useContext(ErrorDialogContext);
  const handleError = (message: string) => {
    setError({
      header: '患者プロフィールの登録に失敗しました',
      message,
      onOk: () => {
        setError();
      },
    });
  };

  const [doFix, fixStatus] = useTransaction(
    () =>
      store.updateFirstReserveProfile().then(async () => {
        const gclid = new URLSearchParams(currentURL.search).get('gclid');
        const finishParams = new URLSearchParamsMonad('')
          .acceptOptional('reservationId', reservationId ? encode(reservationId) : undefined)
          .acceptOptional('gclid', gclid ?? undefined)
          .toString();
        if (store.profile?.card?.id) {
          const fullPath = `${window.location.origin}${Routes.Paths.Payjp3dSecureFinish}?${finishParams}`;
          const payjp3dSecureStore = new Payjp3dSecureStore(store.profile?.card?.id, fullPath);
          await payjp3dSecureStore.redirect3dSecure();
        } else {
          push(`${Routes.Paths.ReservationSuccess}?${finishParams}`, reservationId);
        }
      }),
    (e: Error) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const gqlError: { errors?: { message: string }[] } = e as any;
      handleError(gqlError.errors?.[0]?.message || e.message);
    },
  );

  return {
    doFix,
    fixStatus,
  };
};
